import axios from 'axios';
import { version } from '@mobile/../package.json';

const instance = axios.create();

const loggedInUser = JSON.parse(localStorage.getItem('user'));

instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
instance.defaults.headers.common['Zyp-User-Agent'] = `MOBILE-${version}`;

// add user id as header for easier logging on server side
if (loggedInUser) {
    instance.defaults.headers.common['Zyp-User-ID'] = loggedInUser.id;
}

instance.interceptors.response.use(
    (response) => response,
    (error) => {
        return Promise.resolve(error);
        // only do this when this is on affline event

    },
);

export default instance;
